<template>
  <div id="pageTypeNegotiations">
    <v-container grid-list-xl fluid>
      <v-btn
        class="btn-add"
          color="white"
          small
          absolute
          fab
          :to="{ name: 'AuxTypeNegotiationNew'}"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <v-container fill-height fluid>
          <v-layout fill-height>
            <v-flex xs2>
              Id
            </v-flex>
            <v-flex xs3>
              Nome
            </v-flex>
          </v-layout>
        </v-container>
      <div class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
          v-if="paginatationDisabled"
        ></v-progress-circular>
      </div>
      <v-card class="card-typeNegotiationAux" v-for="(typeNegotiationAux, index) in typeNegotiationAuxs.data" :key="`typeNegotiationAux${typeNegotiationAux.id}`">
        <v-container>
          <v-layout>
            <v-flex xs2>
              <p style="margin: 6px 0px;">{{typeNegotiationAux.id}}</p>
            </v-flex>
            <v-flex xs3>
              <p style="margin: 6px 0px;">{{typeNegotiationAux.name}}</p>              
            </v-flex>
            <v-flex xs7 class="text-xs-right">
              <v-btn fab small :to="{ name: 'AuxTypeNegotiationEdit', params: { id: typeNegotiationAux.id }}" color="primary"><v-icon>edit</v-icon></v-btn>
              <v-btn fab small color="error" @click.stop="clickDeleteTypeNegotiation(index)"><v-icon>delete</v-icon></v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
      <app-pagination v-if="typeNegotiationAuxs && typeNegotiationAuxs.pagination"
        :pagination="typeNegotiationAuxs.pagination"
        :disabled="paginatationDisabled"
        v-on:change-page="changePage"
        ></app-pagination>
      <app-confirm-modal 
        :message="deleteMessage" 
        :dialog="dialog" 
        :modalType="modalType"
        v-on:choose="deleteTypeNegotiation"></app-confirm-modal>
      
      <v-snackbar
        :timeout="3000"
        bottom
        right
        :color="snackbar.color"
        v-model="snackbar.show"
      >
        {{ snackbar.text }}
        <v-btn dark text @click.native="snackbar.show = false" icon> 
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>    
    </v-container>
  </div>
</template>

<script>
import appApi from '../../../plugins/api';
import AppPagination from '../../../components/Pagination';
import ConfirmModal from '../../../components/ConfirmModal';

export default {
  components: {
    'app-pagination' : AppPagination,
    'app-confirm-modal' : ConfirmModal
  },
  data: function() {
    return {
      typeNegotiationAuxs : {},
      paginatationDisabled : false,
      dialog : false,
      deleteTypeNegotiationId : null,
      deleteMessage : '',
      modalType : null,
      snackbar : {}
    }
  },

  computed: {
  },

  mounted: function() {
    this.getAuxTypeNegotiation();
  },

  methods: {
    getAuxTypeNegotiation: function(page) {
      this.paginatationDisabled = true;
      this.typeNegotiationAuxs.data = [];
      appApi.getAuxTypeNegotiations({page : (page ? page : 1)}).then(result => {
        this.typeNegotiationAuxs = result.data;
        this.paginatationDisabled = false;
      }).catch(error => {
        console.log('error', error);
      });
    },
    changePage(page) {
      this.getAuxTypeNegotiation(page);
    },
    clickDeleteTypeNegotiation(index) {
      this.dialog = true;
      this.deleteTypeNegotiationId = index;
      this.modalType = 'error';
      this.deleteMessage = 'Tem certeza que deseja deletar <strong>'+this.typeNegotiationAuxs.data[index].name+'</strong>?';
    },
    deleteTypeNegotiation(confirm) {
      this.dialog = false;
      if (confirm) {
        appApi.deleteAuxTypeNegotiation(this.typeNegotiationAuxs.data[this.deleteTypeNegotiationId].id).then(()=>{
          this.changePage(1);
          this.snackbar = {
            show: true,
            color: "green",
            text: "Apagado com sucesso."
          };
        }).catch(()=>{
          this.changePage(1);
          this.snackbar = {
            show: true,
            color: "error",
            text: "Não foi possível apagar."
          };
        });
      }
    }
  }

};
</script>
<style scoped lang="css">
  #pageTypeNegotiations {
    position: relative;
  }
  #pageTypeNegotiations .btn-add {
    position: fixed;
    top: 90px;
    left: calc(100% - 60px);
  }
  #pageTypeNegotiations .card-typeNegotiationAux {
    margin-bottom: 10px;
  }
</style>

